module.exports = require("core-js/library/fn/is-iterable");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/is-iterable.js
// module id = 225
// module chunks = 35783957827783 70144966829960 114276838955818